<!-- Centered Login Form Wrapper -->
<dx-validation-group
  #loginValidationGroup
  *ngIf="!showRetrieveUsername && !showForgotPassword && !showRegister"
>
  <div class="login-form-wrapper">
    <!-- Error Message -->
    <div class="error-message-container" *ngIf="showErrorMessage">
      <p class="error-message">{{ errorMessage }}</p>
    </div>

    <!-- Username/Email -->
    <div class="user-auth-container-input-wrapper">
      <label for="txtUsername" class="input-label">
        Username or Email
        <span class="required-asterisk">*</span>
      </label>
      <dx-text-box
        id="txtUsername"
        placeholder="Username or Email"
        [(value)]="loginParam.username"
        class="username-input"
        (onEnterKey)="btnLoginClick(null)"
        ccTrimInput
      >
        <dx-validator>
          <dxi-validation-rule
            type="required"
            message="Username or Email is required"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>

    <!-- Password -->
    <div class="user-auth-container-input-wrapper">
      <label for="txtPassword" class="input-label">
        Password
        <span class="required-asterisk">*</span>
      </label>
      <dx-text-box
        id="txtPassword"
        placeholder="Password"
        [(mode)]="passwordMode"
        [(value)]="loginParam.password"
        (onEnterKey)="btnLoginClick(null)"
        class="password-input"
        ccTrimInput
      >
        <dxi-button
          *ngIf="passwordMode === 'password'"
          name="password"
          location="after"
          [options]="passwordShowButton"
        ></dxi-button>
        <dxi-button
          *ngIf="passwordMode !== 'password'"
          name="password"
          location="after"
          [options]="passwordHideButton"
        ></dxi-button>
        <dx-validator>
          <dxi-validation-rule
            type="required"
            message="Password is required"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>

    <!-- Remember Me -->
    <div class="user-auth-container-input-wrapper remember-me">
      <dx-check-box
        [(value)]="loginParam.rememberMe"
        text="Remember me"
        class="custom-check"
      ></dx-check-box>
    </div>

    <!-- Forgot Password -->
    <div class="forgot-password-container">
      <span>Forgot your password?</span>
      <a (click)="btnResetPasswordClick($event)">Reset now</a>
    </div>

    <!-- Sign In Button -->
    <div class="login-button-content">
      <dx-button
        #btnLogin
        text="Sign In"
        class="login-button"
        type="default"
        (onClick)="btnLoginClick($event)"
      ></dx-button>
    </div>

    <!-- Divider -->
    <div class="login-divider" *ngIf="showGoogleAuth">
      <span>
        <span></span>
      </span>
      <div>OR</div>
      <span>
        <span></span>
      </span>
    </div>

    <!-- Google Sign-In Button -->
    <div class="google-signin-container" *ngIf="showGoogleAuth">
      <dx-button
        class="google-signin-button"
        type="default"
        (onClick)="btnGoogleLoginClick($event)"
      >
        <div class="google-button-content">
          <app-icon
            name="google-logo"
            size="16px"
            class="google-logo"
            ariaLabel="Google logo"
          ></app-icon>
          <span>Sign in with Google</span>
        </div>
      </dx-button>
    </div>

    <div class="forgot-password-container">
      <span>Don't have an account?</span>
      <a (click)="btnRegisterNowClick($event)">Register now</a>
    </div>

    <div
      class="retrieve-username-container"
      [class.no-google-auth]="!showGoogleAuth"
    >
      <span>Forgot your username or need to validate your email address?</span>
      <a href="#" (click)="btnRetrieveUsernameClick($event)">Retrieve now</a>
    </div>
  </div>
</dx-validation-group>

<!-- Retrieve Username Component -->
<div *ngIf="showRetrieveUsername" class="retrieve-username-wrapper">
  <app-retrieve-username-or-validate-email
    [isEmbedded]="true"
    (closePanel)="onClosePanelClick()"
  ></app-retrieve-username-or-validate-email>
</div>

<!-- Forgot Password Component -->
<div *ngIf="showForgotPassword" class="forgot-password-wrapper">
  <app-forgot-password
    [isEmbedded]="true"
    (closePanel)="onCloseForgotPasswordPanelClick()"
  ></app-forgot-password>
</div>

<!-- Register Account Component -->
<div *ngIf="showRegister" class="register-account-wrapper">
  <app-register-account
    [isEmbedded]="true"
    (closePanel)="onCloseRegisterPanelClick()"
  ></app-register-account>
</div>

<!-- Loading Panel -->
<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>
